module.exports = __webpack_public_path__ + "static/media/bumba-partitura-1.da9df66c.png";